import React from 'react';
import cn from 'classnames';

import Image from 'next/image';

import Text from '@components/Text';
import Title from '@components/Title';

import s from './AboutAdvantages.module.scss';
import { mainLabels } from './constants';

const AboutAdvantages: React.FC<JSX.IntrinsicElements['div']> = ({ className }) => {
  const classes = cn(s.root, className);
  return (
    <section className={classes}>
      <div className={s.container}>
        <div className={s.row}>
          {mainLabels.map(({ id, title, description, image }, index) => (
            <div className={cn(s.link, index % 2 && s.reverse)} key={id}>
              <div className={s.content}>
                <Title level={2} className={s.title} weight="medium">
                  {title}
                </Title>
                <Text size="large" className={s.description}>
                  <span dangerouslySetInnerHTML={{ __html: description || '-' }} />
                </Text>
              </div>

              {image ? (
                <div className={s.image}>
                  <Image alt={title} src={image} layout="responsive" width={1.3} height={1} />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutAdvantages;
